import { combineReducers } from "redux"

import recentViolations from './recentViolations'
import totalViolations from './totalViolations'
import trafficCongestion from './trafficCongestion'
import trafficDetails from './trafficDetails'

export default combineReducers({
    recentViolations,
    totalViolations,
    trafficCongestion,
    trafficDetails
});



// WEBPACK FOOTER //
// ./src/reducers/dashboard/index.ts